import type { FC } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { loadIntakeAsync, selectOnboarding } from '../../store/onboardingSlice';
import IntakeWizard from '../../components/forms/IntakeWizard';

const OnboardingPage: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { completed } = useAppSelector(selectOnboarding);

  useEffect(() => {
    dispatch(loadIntakeAsync());
  }, [dispatch]);

  useEffect(() => {
    if (completed) {
      navigate('/onboarding/payment');
    }
  }, [completed, navigate]);

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom fontWeight={600}>
          Complete Your Setup
        </Typography>
        <Typography color="text.secondary">
          Tell us about your business so we can configure your Debtornator instance perfectly.
        </Typography>
      </Box>

      <IntakeWizard />
    </Box>
  );
};

export default OnboardingPage;
